import { EVisa2PayCardType } from '../enums/billing/EVisa2PayCardType';

export function normalizeCardNumberDigits(cardNumber: string): string {
  return cardNumber.replace(/\D/g, '');
}

/** Luhn check for card PAN (13–19 digits). */
export function isValidCardNumberLuhn(cardNumber: string): boolean {
  const digits = normalizeCardNumberDigits(cardNumber);
  if (!/^\d{13,19}$/.test(digits)) {
    return false;
  }

  let sum = 0;
  let shouldDouble = false;
  for (let index = digits.length - 1; index >= 0; index -= 1) {
    let digit = Number(digits[index]);
    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }
    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
}

export function detectVisa2PayCardType(
  cardNumber: string,
): EVisa2PayCardType | null {
  const digits = normalizeCardNumberDigits(cardNumber);
  if (digits.startsWith('4')) {
    return EVisa2PayCardType.visa;
  }

  if (/^5[1-5]/.test(digits)) {
    return EVisa2PayCardType.mastercard;
  }

  if (/^2(2[2-9]|[3-6]|7[01])/.test(digits)) {
    return EVisa2PayCardType.mastercard;
  }

  return null;
}
